export default __webpack_public_path__ + "static/media/Template2.af67ed47.png";